import { FilterPill, FilterPillBody, FilterPillRemove } from '@plato/ui/primitives/filter-controls';
import { useTranslation } from 'react-i18next';

export type FilterBadgeProps = {
    category?: string;
    filter?: string;
    onRemove: () => void;
    canRemove?: boolean;
    className?: string;
};

// Adapter onto the Plato UI filter pill — looks only, body stays inert.
export function FilterBadge({ category, filter, onRemove, canRemove = true, className }: FilterBadgeProps) {
    const { t } = useTranslation();

    if (!filter) {
        return null;
    }

    return (
        <FilterPill label={category ?? ''} className={className}>
            <FilterPillBody>{filter}</FilterPillBody>
            {canRemove && (
                <FilterPillRemove
                    aria-label={t('filter_header__delete_button', { ns: 'generic-list' })}
                    onClick={onRemove}
                />
            )}
        </FilterPill>
    );
}
